import React from 'react';
import classNames from 'classnames';

import styles from './Checkbox.module.scss';

interface CheckboxProps {
  id: string;
  label: string;
  selected: boolean;
  onChange: () => void;
  className?: string;
  appearance?: 'box' | 'radio';
}

const Checkbox = ({ id, selected, label, onChange, className, appearance = 'box' }: CheckboxProps) => {
  return (
    <div className={classNames(styles.checkbox_field, className)}>
      <label htmlFor={id} className={classNames('text_small', styles.checkbox_label)}>
        {label}
      </label>
      <input id={id} type="checkbox" checked={selected} onChange={onChange} />
      <span
        className={classNames(styles.checkbox, {
          [styles.box]: appearance === 'box',
          [styles.radio]: appearance === 'radio',
        })}
      />
    </div>
  );
};

export default Checkbox;
